import React, {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';
import { DataCatalog } from '../../types';

type FileSource = 'api' | 'upload';
type ReportFormatFile = { file: File | Blob; source: FileSource };

type BusinessReportEditorContextProps = {
  dataCatalog: DataCatalog | null;
  reportFormatFile: ReportFormatFile | null;
  isInitialRequestComplete: boolean;
  setDataCatalog: Dispatch<SetStateAction<DataCatalog | null>>;
  setReportFormatFile: Dispatch<SetStateAction<ReportFormatFile | null>>;
  setIsInitialRequestComplete: Dispatch<SetStateAction<boolean>>;
};

export const BusinessReportEditorContext =
  createContext<BusinessReportEditorContextProps>({
    dataCatalog: null,
    reportFormatFile: null,
    isInitialRequestComplete: false,
    setDataCatalog: () => {},
    setReportFormatFile: () => {},
    setIsInitialRequestComplete: () => {},
  });

export function BusinessReportEditorProvider({
  children,
}: {
  children: ReactNode;
}): React.JSX.Element {
  // 帳票様式
  const [reportFormatFile, setReportFormatFile] =
    useState<ReportFormatFile | null>(null);
  // データ項目
  const [dataCatalog, setDataCatalog] = useState<DataCatalog | null>(null);
  // 初期リクエスト処理の完了状態
  const [isInitialRequestComplete, setIsInitialRequestComplete] =
    useState(false);

  return (
    <BusinessReportEditorContext.Provider
      value={{
        dataCatalog,
        reportFormatFile,
        isInitialRequestComplete,
        setDataCatalog,
        setReportFormatFile,
        setIsInitialRequestComplete,
      }}
    >
      {children}
    </BusinessReportEditorContext.Provider>
  );
}

export const useBusinessReportEditor = () => {
  return useContext(BusinessReportEditorContext);
};
